import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/code/wealthLevel',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-wealthLevel-index" */ '~/pages/r_code/WealthLevel/pages/index'
        )
    ),
  },
  {
    path: '/code/wealthLevel/level',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-wealthLevel-level" */ '~/pages/r_code/WealthLevel/pages/level'
        )
    ),
  },
  {
    path: '/code/wealthLevel/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-wealthLevel-detail" */ '~/pages/r_code/WealthLevel/pages/detail'
        )
    ),
  },
  {
    path: '/code/wealthLevel/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-wealthLevel-rule" */ '~/pages/r_code/WealthLevel/pages/rule'
        )
    ),
  },
] as RouteConfig[]
